import 'babel-polyfill'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Vuetify from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import api from './store/api'
import VueMeta from 'vue-meta'
import VTooltip from 'v-tooltip'

import '@fortawesome/fontawesome-free/css/all.css'

import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

if (window.location.hostname !== 'localhost') {
  // Broken with new version
  // Sentry.init({
  //   dsn: 'https://ec18fa5a127247d083fefdf833a6f8c6@o69162.ingest.sentry.io/5277573',
  //   integrations: [new VueIntegration({ Vue, attachProps: true })],
  // })
}

Vue.use(VTooltip)
Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.use(VueI18n)
Vue.use(Vuetify, {
  iconfont: 'fa',
})

// Set both 'state.languages' and contentLanguages
let contentLanguages = [
  'en',
  'es',
  'fi',
  'et',
  'ru',
  'de',
  'pt',
  'pl',
  'da',
  'fr',
  'nl',
  'sv',
  'no',
  'zh',
  'ar',
]

let translationsByLang = {}
contentLanguages.forEach((lang) => {
  translationsByLang[lang] = {}
})

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      site: 'Site name',
    },
    ee: {
      site: 'Saidi nimi',
    },
  },
})

const isMainDomain = ['www.costasolrent.com', 'test.costasolrent.com'].includes(
  document.location.host
)
const isLocalhost =
  document.location.host.includes('localhost:') ||
  document.location.host.includes('192.168.')
if (!isMainDomain && !isLocalhost) {
  let forwardUrl = document.location.href.replace(
    document.location.host,
    'www.costasolrent.com'
  )
  if (document.location.pathname === '/' || !document.location.pathname) {
    if (
      ['costasolrent.ee', 'www.costasolrent.ee'].includes(
        document.location.host
      )
    ) {
      forwardUrl = 'https://www.costasolrent.com/et'
    } else if (
      ['costasolrent.fi', 'www.costasolrent.fi'].includes(
        document.location.host
      )
    ) {
      forwardUrl = 'https://www.costasolrent.com/fi'
    } else if (['costasolrent.es'].includes(document.location.host)) {
      forwardUrl = 'https://www.costasolrent.com/es'
    }
  }
  location.href = forwardUrl
} else {
  api.getSiteTranslations().then((translations) => {
    if (translations && translations.items) {
      translations.items.forEach((one) => {
        contentLanguages.forEach((lang) => {
          translationsByLang[lang][one.fieldName] = one['translation_' + lang]
        })
        translationsByLang.fi[one.fieldName] = one['translation_fi']
      })
    }

    contentLanguages.forEach((lang) => {
      i18n.setLocaleMessage(lang, translationsByLang[lang])
    })
    store.commit('setTranslationsByLang', translationsByLang)

    new Vue({
      router,
      i18n,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app')
  })
}
